import { Section } from '../../../entities/Metadata';
import { namesof } from '../../../store/services/metadataService';
import { Calendar, CalendarException, ICalendarAttrs } from '../../../store/calendar/common';
import { ISubentitiesListSettings } from '../../common/SubentitiesList';
import { notUndefined } from '../../utils/common';
import WorkWeekSettingsTooltip from '../../common/sectionsControl/uiControls/workWeekSettingsControl/WorkWeekSettingsTooltip';
import GlobalCalendarExceptionsListTooltip from '../../common/sectionsControl/uiControls/globalCalendarExceptionsListControl/GlobalCalendarExceptionsListTooltip';
import WorkWeekTooltip from '../../common/sectionsControl/uiControls/myWorkWeekControl/WorkWeekTooltip';
import MyCalendarExceptionsListTooltip from '../../common/sectionsControl/uiControls/myCalendarExceptionsListControl/MyCalendarExceptionsListTooltip';

export const DETAILS_SECTION_ID = '197bd5ff-8e00-43a5-a0c6-0a0b8e0d5b3d';

const detailCalendarSection:  Section =
{
    id: DETAILS_SECTION_ID,
    name: 'Details',
    isSelected: true,
    isOpen: true,
    isAccessible: true,
    settings: { iconName: "PPMXSectionDetails" },
    uiControls: [
        {
            id: 'e7e292-cb4f-474c-8e5c-ccdee1038b95',
            type: 'FieldsArea',
            settings: {
                fields: {
                    column1: namesof<ICalendarAttrs>(['Name', 'Status', 'Description']),
                    column2: []
                }
            }
        }
    ],
};


export const userCalendarSections: Section[] = [
    detailCalendarSection,
    {
        id: 'c181927e-839a-417a-8321-c133a5852df8',
        name: 'Calendar',
        isSelected: true,
        isOpen: true,
        isAccessible: true,
        settings: {
            iconName: "PPMXUserCalendarWorkWeek",
            tooltip: <WorkWeekTooltip />,
        },
        uiControls: [
            {
                id: '4e32dac0-60de-43c0-883e-1d68404f300b',
                type: 'MyWorkWeekControl',
                settings: []
            }
        ]
    },
    {
        id: '7e981164-a602-4044-a052-cadf35353396',
        name: 'Calendar Exceptions',
        isSelected: true,
        isOpen: true,
        isAccessible: true,
        settings: {
            iconName: "PPMXUserCalendar",
            tooltip: <MyCalendarExceptionsListTooltip />
        },
        uiControls: [
            {
                id: 'f33e6305-ee7f-4c4f-82ee-00fa219773d1',
                type: 'MyCalendarExceptionsListControl',
                settings: [{
                    displayFields: namesof<CalendarException>(['name', 'start', 'end', 'days', 'expectedHrs', 'description']),
                } as ISubentitiesListSettings]
            }
        ]
    }
];

export const globalCalendarSections: Section[] = [
    detailCalendarSection,
    {
        id: 'd8cc9640-eec4-42ba-8323-e19820d71481',
        name: 'Work Week',
        isSelected: true,
        isOpen: true,
        isAccessible: true,
        settings: {
            iconName: "CalendarWorkWeek",
            tooltip: <WorkWeekSettingsTooltip />,
        },
        uiControls: [
            {
                id: 'ac2aeffe-5dcf-4408-bffc-e4239f0b8a7d',
                type: 'WorkWeekSettingsControl',
                settings: []
            }
        ]
    },
    {
        id: '6cb01d78-669b-4e99-8809-7dbda3551f07',
        name: 'Calendar Exceptions',
        isSelected: true,
        isOpen: true,
        isAccessible: true,
        settings: {
            iconName: "PrimaryCalendar",
            tooltip: <GlobalCalendarExceptionsListTooltip />
        },
        uiControls: [
            {
                id: '4e32dac0-60de-43c0-883e-1d68404f300b',
                type: 'GlobalCalendarExceptionsListControl',
                settings: {
                    displayFields: namesof<CalendarException>(['name', 'start', 'end', 'days', 'expectedHrs', 'description']),
                } as ISubentitiesListSettings
            }
        ]
    }
];
